module.exports = __webpack_public_path__ + "img/source05_3.f4cf7b34.png";